import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { GlobalVariables } from 'app/services/globals';
import { ConnectionAuthKind } from 'shell-models-lib';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';

export const databricksMetadata: IDynamicLinkedServiceTypeMetadata = async () => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.databricks.linkedServiceType,
        displayName: stringResources.Activity_Category_Databricks,
        linkedServiceKind: 'table',
        icon: {
            className: 'svg-i_databricks_16x16'
        },
        supportedInTrident: GlobalVariables.enableDatabricks,
        supportAutoFillCopilotInput: GlobalVariables.enableDatabricks,
        isKnownInPipelineContext: GlobalVariables.enableDatabricks,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'DatabricksMultiCloud' as ResourceKind
        },
        supportedAuthKindsInTrident: [ConnectionAuthKind.Key, ConnectionAuthKind.Basic],
        supportCopyJobSource: GlobalVariables.enableDatabricks,
        supportCopyJobSink: GlobalVariables.enableDatabricks,
        supportMultipleIncrementalColumns: true,
        notSupportFabricBuiltInStaging: true,
        isFirstClass: true,
        supportDatasetV2: true,
        supportFirstClassParameterExperience: true,
        copySourceTypes: [adfModelTypeMap.databricks.copySourceType],
        copySinkTypes: [adfModelTypeMap.databricks.copySinkType],
        category: ['Database'],
        fetchNestedNavTable: true
    };

    if (GlobalVariables.enableDatabricksOAuth) {
        metadata.supportedAuthKindsInTrident!.push(ConnectionAuthKind.OAuth2);
    }

    return metadata;
};
